import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";

import { Text as Typography } from "@performyard/py-components";

import Alert from "../../../../../../components/Alert";
import DatePicker from "../../../../../../components/Inputs/DatePicker";

export const DateWithErrors = ({
	value,
	setValue,
	label,
	errorMessage,
	disabled,
}: {
	value: Date | "";
	setValue: (date?: Date | null) => void;
	label: string;
	errorMessage: string | null;
	disabled?: boolean;
}) => {
	const [ref] = useAutoAnimate();

	return (
		<div ref={ref} className="flex flex-col gap-2">
			<label htmlFor={label}>
				<Typography size="paragraph-3" weight="semi-bold" color={errorMessage?.length ? "red-6" : undefined}>
					{label}
				</Typography>
			</label>
			<DatePicker
				textInputClassName={errorMessage?.length ? "rounded ring-1 ring-red-6" : ""}
				inputId={label}
				value={value || ""}
				onChange={setValue}
				placeholder="mm/dd/yyyy"
				hasIcon
				disabled={disabled}
			/>
			{errorMessage && <Alert type="error" message={errorMessage} />}
		</div>
	);
};
